import {combineReducers, createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {company} from './company/reducers';
import {global} from './global/reducers';
import {df} from './discussionForum/reducers';
import {country} from './country/reducers';
import {rate} from './rate/reducers';
import {currency} from './currency/reducers';
import {credit} from './creditStrategy/reducers';
import {digital} from './digitalAsset/reducers';

export const rootReducer = {
    global,
    company,
    country,
    rate,
    currency,
    credit,
    df,
    digital,
};
const devTool =
    process.env.NODE_ENV === 'development'
        ? window.__REDUX_DEVTOOLS_EXTENSION__
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : compose
        : compose;

const store = createStore(
    combineReducers(rootReducer),
    compose(applyMiddleware(thunkMiddleware), devTool),
);

export default store;
